import { Observable } from "rxjs";
import { config } from "../../config/config";
import { utilService } from "../utils";

/**
 * Api services for emergencybroadcast component
 */
export const emergencybrodcastService = {
  getEmergencybroadcasts,
  saveEmergencyBroadcast,
  updateEmergencyBroadcast,
};

function getEmergencybroadcasts(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.emergencybroadcast, {
      method: "GET",
      headers: {
        Authorization: data,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function saveEmergencyBroadcast(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.emergencybroadcast, {
      method: "POST",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
function updateEmergencyBroadcast(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.emergencybroadcast + data.id, {
      method: "PUT",
      headers: {
        Authorization: data.token,
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
